import React from "react";
import {Divider} from "antd";

export default function Features() {

    const options = [
        {
            title: "صفحه اختصاصی مدرسه",
            description: 'در بازار هوشمند آموزش شما می توانید یک سایت اختصاصی با قابلیت های استثنایی داشته باشید و در کنار اطلاع رسانی عمومی به صورت خبر و گالری تصاویر از دانش آموزان خود در جهت تولید محتوای درسی و علمی بصورت وبلاگ بهرمند شوید و در کنار آن می توانید خدمات علمی و آموزشی مدرسه را در قالب جشنواره های آنلاین در معرض دید عموم قرار دهید',
            icon: "fal fa-browser"
        },
        {
            title: "سیستم پیام‌رسان",
            description: 'در بازار هوشمند آموزش شما می توانید یک سایت اختصاصی با قابلیت های استثنایی داشته باشید و در کنار اطلاع رسانی عمومی به صورت خبر و گالری تصاویر از دانش آموزان خود در جهت تولید محتوای درسی و علمی بصورت وبلاگ بهرمند شوید و در کنار آن می توانید خدمات علمی و آموزشی مدرسه را در قالب جشنواره های آنلاین در معرض دید عموم قرار دهید',
            icon: "fal fa-bells"
        },
        {
            title: "جلسات اولیا و مربیان",
            description: 'مدیر میتواند در سیستم بازار هوشمند آموزش رویداد های مورد نیاز خود را ایجاد کند برای مثال جلساتی با اولیا و یا مربیان و حتی کل دانش آموزان به صورت کلی داشته باشد و روز و ساعت مورد نظر مدیر همه در جلسه مدیر حضور داشته باشند',
            icon: "fal fa-mind-share"
        },
        {
            title: "امتحانات",
            description: 'آزمون آنلاین همیشه چالش های خودش را داشته است اما بازار هوشمند آموزش تلاش خود را کرده است که یکی از کاملترین سیستم های آزمون آنلاین را داشته باشد به صورتی که دبیر میتواند صورت سوالات را به صورت متنی عکس و حتی صوتی بفرستند و جواب را به صورت تشریحی و تستی و یا صوتی از دانش آموز بخواهد',
            icon: "fal fa-file-signature"
        },
        {
            title: "تکالیف",
            description: 'اگر نیاز به گرفتن تکالیف دانش آموزان را دارید بازار هوشمند آموزش بهترین راه حل هارا در این مورد برای شما دارد ... شما میتوانید بر روی هر جلسه از درس هایتان از دانش آموزان تکلفی بخواهید که دانش آموز میتواند به صورت عکس - فیلم -پی دی اف - پاورپوینت و غیره بفرستد و دبیر به صورت دسته بندی شده تکالیف را بررسی کند',
            icon: "fal fa-pencil"
        },
        {
            title: "پرسش و پاسخ",
            description: 'یکی از چالش های کلاس های آنلاین سوال هایی هست که برای دانش آموزان بعد از کلاس پیش می آید، زیبات‌ران برای این منظور راهکار پرس و پاسخ را برای هر موضوع متناسب با آن جلسه دیده است',
            icon: "fal fa-comment-lines"
        },
        {
            title: "بازپخش دائمی کلاس",
            description: 'علاوه بر کلاس های آنلاین شما در زیبات‌ران میتوانید کلاس های آفلاین هم داشته باشید به این معنی که تصویر و صدا خود و حتی صفحه ی لپتاپ خود را فیلم برداری کنید و در سیستم به عنوان درس جدید بارگذاری کنید تا دانش آموزانتان استفاده کنند',
            icon: "fal fa-presentation"
        },
        {
            title: "کلاس درس آنلاین",
            description: 'در بازار هوشمند آموزش شما میتوانید کلاس های آنلاین و مجازی داشته باشید و تمام دانش آموزان به صورت همزمان تصویر - صدا و صفحه نمایش دبیر را داشته باشند در کنار این موضوع دبیر میتواند پاورپوینت - پی دی اف - ویدیو خود را با دانش آموزان به اشتراک بگذارد و حتی بر روی وایت برد بنویسد',
            icon: "fal fa-laptop"
        },
    ];

    return (
        <div className="row p-5 bg-white b-15 mt-5">
            <div className="col-12 text-center">
                <h3>امکانات بازار هوشمند آموزش</h3>
            </div>
            {options.map((item, key) =>
                <div className="col-12">

                    <div className="d-flex text-left my-3 col-12 ">
                        <i style={{margin: 5, fontSize: 20, color: '#00CDFF'}} className={item.icon}/>
                        <h5 className="m-2">{item.title}</h5>
                    </div>
                    <p>{item.description}</p>
                    <Divider/>
                </div>
            )}
        </div>
    )
}